import { render, staticRenderFns } from "./Android.vue?vue&type=template&id=0bbd0c76&"
import script from "./Android.vue?vue&type=script&lang=js&"
export * from "./Android.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports